import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MenuPage from "@/pages/MenuPage";
import AdminPage from "@/pages/AdminPage";
import LocationMenuPage from "@/pages/LocationMenuPage";
import LocationOrdersPage from "@/pages/LocationOrdersPage";
import FridgeLayoutPage from "@/pages/FridgeLayoutPage";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-gray-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MenuPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/loc/:slug" element={<LocationMenuPage />} />
          <Route path="/loc/:slug/orders" element={<LocationOrdersPage />} />
          <Route path="/loc/:slug/fridge" element={<FridgeLayoutPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
